import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import ModalContainer from "components/ModalContainer";
import { OutlineButton } from "components/buttons/OutlineButton";
import { SolidWarnButton } from "components/buttons/SolidWarnButton";

const RemoveRuleModal = ({
  open,
  rule,
  isSaving = false,
  onCancel,
  onConfirm,
}) => {
  const theme = useTheme();

  return (
    <ModalContainer display={open} modalWidth="500px">
      <Box sx={{ padding: "0 10px", textAlign: "center" }}>
        <Typography
          sx={{
            color: theme.palette.primary.main,
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.customFontSize[5],
            fontWeight: theme.typography.customFontWeight[3],
            marginBottom: "20px",
          }}
        >
          Remove IPv4 ACL Rule
        </Typography>

        <Typography
          sx={{
            color: theme.palette.primary.greyPrimary,
            fontSize: theme.typography.customFontSize[3],
            fontFamily: theme.typography.fontFamily,
            fontWeight: theme.typography.customFontWeight[0],
            wordBreak: "break-word",
          }}
        >
          Are you sure you want to remove IPv4 ACL rule SEQ {rule?.seq}?
        </Typography>

        <Box
          sx={{
            marginTop: "20px",
            paddingTop: "20px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <OutlineButton
            sx={{ marginRight: "20px" }}
            width="100px"
            height="32px"
            onClick={onCancel}
            disabled={isSaving}
          >
            Cancel
          </OutlineButton>
          <SolidWarnButton width="100px" height="32px" onClick={onConfirm} disabled={isSaving}>
            Remove
          </SolidWarnButton>
        </Box>
      </Box>
    </ModalContainer>
  );
};

export default RemoveRuleModal;
